import React from "react";
import { CONTACT_EMAIL } from "../../data/content";
export function Footer() {
  return <footer className="bg-black py-14 px-4 border-t-2 border-[#e10600]" data-id="element-97" data-mp="207t2wbhjjpmm">
      <div className="max-w-3xl mx-auto text-center" data-id="element-98" data-mp="209x6esbj2mmd">
        <div className="font-display text-3xl sm:text-4xl text-white uppercase" data-id="element-99" data-mp="2f3sazm4nhprr">
          🍕 MEGAPACK 72HS™
        </div>
        <p className="font-condensed text-xl text-[#e10600] tracking-wide mt-2" data-id="element-100" data-mp="2a6ic7fvdg1r9">
          El sistema N°1 para emprender desde la cocina en Argentina.
        </p>
        <p className="text-neutral-400 text-sm mt-4 leading-relaxed max-w-2xl mx-auto" data-id="element-101" data-mp="1hhun197i4s8f">
          Porque tener tu propio negocio de comidas no debería costarte meses de confusión, dudas y
          domingos perdidos buscando en Google.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-6 text-sm text-neutral-300" data-id="element-102" data-mp="1rd63bvyk67ia">
          <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-[#e10600]" data-id="element-103" data-mp="yqlbkue67te7">
            📧 {CONTACT_EMAIL}
          </a>
          <span data-id="element-104" data-mp="1eilugye9evxz">📲 @megapack72hs</span>
          <span data-id="element-105" data-mp="1ehkfiiu4hpaz">🌐 www.megapack72hs.com</span>
        </div>

        <p className="text-neutral-600 text-xs mt-8 leading-relaxed" data-id="element-106" data-mp="1ij5ss5akk5lp">
          © Megapack 72hs™ 2026 — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>

        <blockquote className="font-condensed text-lg sm:text-xl text-neutral-300 tracking-wide mt-8" data-id="element-107" data-mp="1s85sjqwwb50y">
          🍕 "Tu cocina ya tiene todo lo que necesitás para empezar."
          <br data-id="element-108" data-mp="zk1iyub7e7sz" />
          <span className="text-[#e10600]" data-id="element-109" data-mp="zluuamwrhg7b">"El sistema es lo único que faltaba."</span>
        </blockquote>
      </div>
    </footer>;
}